import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: ReactNode;
  className?: string;
  id?: string;
  alternate?: boolean;
}
export function Section({
  children,
  className = '',
  id,
  alternate = false
}: SectionProps) {
  return <section id={id} className={`py-20 md:py-28 px-6 w-full ${alternate ? 'bg-[#1e2d3d]' : 'bg-[#1a2332]'} ${className}`} data-id="element-233">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="max-w-[680px] mx-auto" data-id="element-234">
        {children}
      </motion.div>
    </section>;
}